import { ValidationResult } from "@components/WizardCst/types";
import { validateConfig } from "@pages/Contents/V2/Corporate/Catalog/Enrollment/config/enrollmentFieldsConfig";
import { EnrollmentStepData, StaticGroupWizardData } from "./types";

export const validateGroupInfo = (
  data: StaticGroupWizardData,
): ValidationResult => {
  const errors: Record<string, string> = {};
  if (!data.name?.trim()) errors.name = "required";
  return { valid: Object.keys(errors).length === 0, errors };
};

export const validateEnrollMode = (
  data: EnrollmentStepData,
): ValidationResult => {
  const { valid, errors } = validateConfig(data.enrollConfig);
  return { valid, errors: errors as Record<string, string> };
};

export const skipEnrollMode = (data: EnrollmentStepData): boolean =>
  data.loSelections.length === 0;
